import Panel from "Components/Panel/Panel";
import React, { useEffect, useState } from "react";
import RightArrow from "../../../../../Components/SideBar/assets/icons/right-arrow.png"
import OptionsPanel from "Components/OptionsPanel/OptionsPanel";
import ExecuteAxios from "Components/ExecuteAxios/ExecuteAxios";
import ExternalProductionCost from "./ExternalProductionCost";

const ExternalEmployeeList = ({
    costDayIdSelecteds,
    onUpdateCostDayIdSelecteds,
    dsItem,
    dsMonth,
    currentMonth,
    showNewEmployeeMonthPanel,
    onUpdateInsertEmployee,
    handleClose,
    getButtonToShowSubtitles,
    panelListCostDay,
    updatePanelCostSpreadsheet,
    onUpdatePanelCostSpreadsheet,
    onUpdateIdEmployee,
    onUpdateReloadSalaryEmployeesCost
}) => {
    const [dsEmployee, setDsEmployee] = useState(null)

    const costDayStyle = {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '95%',
        zIndex: '0',
        overflow: 'hidden'
    }

    useEffect(() => {
        const fetchData = async () => {
            const parameters = {
                externalEmployeeDayId: costDayIdSelecteds[0]
            }
            const employeesListEmployee = await ExecuteAxios.api('get', '/external-employee-day/name/', { params: parameters });
            if (employeesListEmployee) {
                setDsEmployee(employeesListEmployee)
            }
        }
        if (!costDayIdSelecteds || costDayIdSelecteds.length != 1) {
            setDsEmployee(null)
        } else {
            fetchData();
        }
    }, [costDayIdSelecteds])

    function getEmployeeEmployeesPanel() {
        if (costDayIdSelecteds && costDayIdSelecteds.length === 1) {
            return (
                {
                    label: dsEmployee || 'Selecione um registro',
                    component: (
                        getEmployeeDayPanel()
                    )
                }
            )
        } else {
            return (
                {
                    label: dsEmployee || 'Selecione um registro',
                    component: (
                        null
                    )
                }
            )
        }
    }

    function getEmployeeDayPanel() {
        return (
            <ExternalProductionCost
                costDayIdSelecteds={costDayIdSelecteds}
                currentMonth={currentMonth}
                handleClose={handleClose}
                getButtonToShowSubtitles={getButtonToShowSubtitles}
            />
        )
    }

    return (
        <Panel titlePage={dsMonth + ' - ' + dsItem}
            style={costDayStyle}
            canViewCRUD={true}
            componentRightButtons={showNewEmployeeMonthPanel ? null :
                <button
                    style={{
                        backgroundImage: `url(${RightArrow})`,
                        backgroundSize: '30px 30px',
                        width: '35px',
                        height: '35px',
                        backgroundRepeat: 'no-repeat',
                        backgroundColor: 'transparent',
                        border: 'none',
                        cursor: 'pointer',
                        alignItems: 'center'
                    }}
                    onClick={handleClose}
                />
            }
            subtitlesPanelBottom={getButtonToShowSubtitles()}
        >
            <OptionsPanel
                options={[
                    {
                        label: 'Produções externas',
                        component: panelListCostDay,
                    },
                    getEmployeeEmployeesPanel()
                ]}
                heigthLess={'60px'}
                mainPanelStyle={{ height: 'calc(100% - 56px)' }}
            />
        </Panel>
    )
}

export default ExternalEmployeeList;